import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDataTable,{staticClass:"elevation-1",attrs:{"fixed-header":"","height":_vm.tableHeight,"headers":_vm.headers,"items":_vm.modelList,"options":_vm.options,"loading":_vm.loading,"server-items-length":_vm.paginatorTotal,"footer-props":_vm.footerProps},on:{"update:options":function($event){_vm.options=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }